<h2 mat-dialog-title>Seleccione el nuevo estado:</h2>


<mat-dialog-content [formGroup]="form">

    <mat-form-field appearance="outline">

        <mat-select placeholder=" Seleccione "
            formControlName="nuevoEstado">

            <mat-option [value]="item.codigo" *ngFor="let item of listaEstados">{{item.descripcion}}</mat-option>

        </mat-select>

    </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions>

    <button class="mat-raised-button"
            (click)="close()">
        Cancelar
    </button>

    <button class="mat-raised-button mat-primary"
            (click)="save()">
        Aceptar
    </button>

</mat-dialog-actions>
